import React from 'react'
import { BlankBox } from './Blank.elements'

const Blank = () => {
  return (
   <BlankBox />
  )
}

export default Blank